import { useEffect, useState } from 'react';
import { AiOutlineDeliveredProcedure } from 'react-icons/ai';
import { FaTruck } from 'react-icons/fa';
import { FiRefreshCcw } from 'react-icons/fi';
import { IoToday } from "react-icons/io5";
import { fetchAllDashboardDataAPI } from '../../utils/api';
import { toast } from 'react-toastify';
import withAuth from '../../utils/withAuth';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const DashboardOverview = () => {
    const [deliveredorder, setDeliveredOrder] = useState(null);
    const [pendingorder, setPendingOrder] = useState(null);
    const [processorder, setProcessOrder] = useState(null);
    const [totalorder, setTotalOrder] = useState(null);
    const [confirmorder, setConfirmOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDashboardAllOrderTypeAgentOrder();
    }, []);

    const getDashboardAllOrderTypeAgentOrder = async () => {
        try {
            const res = await fetchAllDashboardDataAPI('super-admin-get-dashboard-all-order-type-data');
            if (res.data.status === 1) {
                setDeliveredOrder(res.data.delivered);
                setPendingOrder(res.data.pending);
                setConfirmOrder(res.data.confirmorder);
                setProcessOrder(res.data.process);
                setTotalOrder(res.data.totalorder);
            } else {
                toast.warning("Check your connection");
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const renderCard = (title, value, icon, bgColor) => (
        <div className="card radius-10 overflow-hidden w-100">
            <div className="d-flex overbody">
                <div className="icons" style={{ background: bgColor }}>
                    {icon}
                </div>
                <div className="ordertype">
                    <p>{title}</p>
                    <h2>{loading ? <Skeleton width={60} height={30} /> : value}</h2>
                </div>
            </div>
        </div>
    );

    return (
        <div className="dashboardoverview">
            {renderCard('New Orders', confirmorder, <IoToday />, "#4e9191")}
            {renderCard('Order Pending', pendingorder, <FiRefreshCcw />, "#0e7c52")}
            {renderCard('Order Processing', processorder, <FaTruck />, "#00CED1")}
            {renderCard('Order Delivered', deliveredorder, <AiOutlineDeliveredProcedure />, "#c779db")}
            {renderCard('Total Orders', totalorder, <IoToday />, "#597e0d")}
        </div>
    );
};

export default withAuth(DashboardOverview);
